<template>
  <v-container fluid>
    <v-row>
      <v-col class="pb-0" cols="10">
        <v-tabs v-model="tabs" center-active fixed-tabs>
          <v-tab>운전이력</v-tab>
          <v-tab>고장이력</v-tab>
        </v-tabs>
      </v-col>
      <v-col class="pb-0" cols="2">
        <v-select
          outlined
          solo
          dense
          hide-details
          :items="comboList2"
          v-model="select2"
        >
        </v-select>
      </v-col>
      <v-col cols="2">
        <v-select
          outlined
          solo
          dense
          hide-details
          :items="comboList"
          v-model="select"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col class="pt-0">
        <v-tabs-items
          v-model="tabs">
          <v-tab-item>
            <v-row>
              <v-col cols="8"></v-col>
              <v-col class="d-inline-flex justify-end align-center">
                <date-picker :date="startDate"></date-picker>
                <div class="px-5 text-subtitle-1 font-weight-bold"> ~ </div>
                <date-picker :date="endDate"></date-picker>
                <v-btn outlined class="default-btn mx-5" small @click="retrieveGrid">조회</v-btn>
                <v-btn outlined class="mr-5 excel_down" small @click="excelDown">엑셀다운로드</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <real-grid
                  ref="dataGrid"
                  class="mt-1 mb-5 w-full"
                  :options="grid.gridOption"
                  :fields="grid.gridFields"
                  :columns="grid.gridColumns"
                  :height="grid.height"
                  :retrieve-api="gridRetrieveApi"
                ></real-grid>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="8"></v-col>
              <v-col class="d-inline-flex justify-end align-center">
                <date-picker :date="startDate"></date-picker>
                <div class="px-5 text-subtitle-1 font-weight-bold"> ~ </div>
                <date-picker :date="endDate"></date-picker>
                <v-btn outlined class="default-btn mx-5" small @click="retrieveGrid2">조회</v-btn>
                <v-btn outlined class="mr-5 excel_down" small @click="excelDown2">엑셀다운로드</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <real-grid
                  ref="dataGrid2"
                  class="mt-1 mb-5 w-full"
                  :options="grid.gridOption"
                  :fields="errorGrid.gridFields"
                  :columns="errorGrid.gridColumns"
                  :height="grid.height"
                  :retrieve-api="gridRetrieveErrorApi"
                ></real-grid>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getWorkRecord, getWorkErrorRecord } from '@/api/ess/siteWork'
import day from 'dayjs'
import DatePicker from '@/components/monitoring/DatePicker'
import RealGrid from '@/components/grid/Realgrid'
import Message from '@/utils/message'

export default {
  components: {
    DatePicker,
    RealGrid
  },
  props: {
    site_id: { type: String, default: '' },
    essData: { type: [Object, Object], default: undefined }
  },
  data() {
    return {
      tabs: 0,
      date: '',
      date2: '',
      comboList2: [
        {
          text: '태양광 인버터',
          value: 'PVPCS'
        },
        {
          text: 'ESS PCS',
          value: 'EPCS'
        },
        {
          text: '배터리',
          value: 'BSC'
        }
      ],
      select: '',
      select2: 'PVPCS',
      startDate: day(Date.now()).subtract(31, 'day').format('YYYY-MM-DD'),
      endDate: day(Date.now()).format('YYYY-MM-DD'),
      essResult: [],
      PVPCS: [],
      EPCS: [],
      BSC: [],
      isPvpcsSelected: true,
      isEpcsSelected: false,
      isBscSelected: false,
      epcsPcodeid: '',
      pvpcsPcodeid: '',
      bscPcodeid: '',
      workRecordResult: [],
      grid: {
        height: 442.5,
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridFields: [
          { fieldName: 'date', dataType: 'string' },
          { fieldName: 'time', dataType: 'string' },
          { fieldName: 'subcomp', dataType: 'string' },
          { fieldName: 'run_status', dataType: 'string' }
        ],
        gridColumns: [
          {
            name: 'date',
            fieldName: 'date',
            header: {
              text: '일자'
            },
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            // editable 옵션이 false 일 경우, 수정할 수 없다.
            editable: false
          },
          {
            name: 'time',
            fieldName: 'time',
            header: {
              text: '시간'
            },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'subcomp',
            fieldName: 'subcomp',
            header: {
              text: '인버터 번호'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          },
          {
            name: 'run_status',
            fieldName: 'run_status',
            header: {
              text: '이력'
            },
            renderer: {
              type: 'icon',
              iconCallback: function (grid, cell) {
                let image = cell.value === '운전' || cell.value === '대기' ? 'green' : 'red'
                return `/external/runImage/running_${image}.png`
              },
              iconHeight: 15,
              iconWidth: 15
            },
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          }
        ]
      },
      errorGrid: {
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridColumns: [],
        gridFields: [
          { fieldName: 'date', dataType: 'string' },
          { fieldName: 'time', dataType: 'string' },
          { fieldName: 'subcomp', dataType: 'string' },
          { fieldName: 'status1', dataType: 'string' },
          { fieldName: 'status2', dataType: 'string' },
          { fieldName: 'status3', dataType: 'string' },
          { fieldName: 'status4', dataType: 'string' }
        ]
      }
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.dataGrid.retrieve()
    })
  },
  computed: {
    status1List() {
      if (this.select2 === 'BSC') {
        return [
          {
            value: '0.0',
            label: '이상없음'
          },
          {
            value: '1.0',
            label: '충전 과전류 경고'
          },
          {
            value: '4.0',
            label: '충전 전력 제한 초과 경고'
          },
          {
            value: '16.0',
            label: '다른 고장에 의한 렉 경고'
          },
          {
            value: '2.0',
            label: '방전 과전류 경고'
          },
          {
            value: '8.0',
            label: '방전 전력 제한 초과 경고'
          },
          {
            value: '32.0',
            label: '전체 렉 경고'
          }
        ]
      } else if (this.select2 === 'EPCS') {
        return [
          {
            value: '0.0',
            label: '이상없음'
          },
          {
            value: '64.0',
            label: 'AC S상 과전류'
          },
          {
            value: '4096.0',
            label: 'AC 전압 저전압'
          },
          {
            value: '16384.0',
            label: 'AC 계통 주파수 낮음'
          },
          {
            value: '32768.0',
            label: 'AC 계통 주파수 높음'
          },
          {
            value: '8.0',
            label: 'AC전류 오프셋 에러'
          },
          {
            value: '2048.0',
            label: 'AC R-S-T상 주파수 에러'
          },
          {
            value: '1.0',
            label: 'AC R상 과전류' + ',' + 'DC-link 과전압'
          },
          {
            value: '32.0',
            label: 'AC T상 과전류'
          },
          {
            value: '8192.0',
            label: 'AC전압 과전압'
          },
          {
            value: '512.0',
            label: 'AC 전류 차이 큼'
          },
          {
            value: '2.0',
            label: 'AC 충전 에러' + ',' + '배터리 저전압'
          },
          {
            value: '16.0',
            label: 'DC 전류 오프셋 에러'
          },
          {
            value: '256.0',
            label: 'DC 과전류'
          },
          {
            value: '1024.0',
            label: 'Stack 전류 차이 큼'
          },
          {
            value: '4.0',
            label: '배터리 과전압'
          }
        ]
      } else if (this.select2 === 'PVPCS') {
        return [
          {
            value: '0.0',
            label: '이상없음'
          },
          {
            value: '1.0',
            label: '문열림. 비상정지' + ',' + '리액터 과온'
          },
          {
            value: '2.0',
            label: 'AC 차단기(Q2) 상태' + ',' + '변압기 과온'
          },
          {
            value: '4.0',
            label: 'DC 차단기(Q2) 상태' + ',' + '계통 과주파수'
          },
          {
            value: '8.0',
            label: 'U상 IGBT 이상' + ',' + '계통 저주파수'
          },
          {
            value: '16.0',
            label: 'V상 IGBT 이상' + ',' + 'DC 입력 측 서지어레스트'
          },
          {
            value: '32.0',
            label: 'W상 IGBT 이상' + ',' + 'AC 출력 측 서지 어레스트'
          },
          {
            value: '64.0',
            label: '입력 과전압' + ',' + '파워소자 과온' + ',' + 'Passive Anti-IsLanding for JP'
          },
          {
            value: '128.0',
            label: '입력 저전압' + ',' + '단상 결상' + ',' + 'Active Anti-Islanding for JP'
          }
        ]
      }
      return [{
        value: '0.0',
        label: '이상없음'
      }]
    },
    status2List() {
      if (this.select2 === 'BSC') {
        return [
          {
            value: '0.0',
            label: '이상없음'
          },
          {
            value: '64.0',
            label: '충전 과전류 고장'
          },
          {
            value: '256.0',
            label: '충전 전력 제한 초과 고장'
          },
          {
            value: '1024.0',
            label: '오프라인 렉 개수 초과 고장'
          },
          {
            value: '4096.0',
            label: '전체 렉 고장'
          },
          {
            value: '128.0',
            label: '방전 과전류 고장'
          },
          {
            value: '512.0',
            label: '방전 전력 제한 초과 고장'
          },
          {
            value: '2048.0',
            label: '초기화 고장'
          }
        ]
      } else if (this.select2 === 'EPCS') {
        return [
          {
            value: '0.0',
            label: '이상없음'
          },
          {
            value: '8.0',
            label: 'AC 메인 MC 에러'
          },
          {
            value: '32.0',
            label: 'AC 충전 MC 에러'
          },
          {
            value: '1.0',
            label: 'DC-link전압 차이 큼'
          },
          {
            value: '4.0',
            label: 'DC 충전 에러'
          },
          {
            value: '64.0',
            label: 'DC충전 MC에러'
          },
          {
            value: '16.0',
            label: 'DC메인 MC에러'
          },
          {
            value: '4096.0',
            label: 'Stack1 퓨즈 열림'
          },
          {
            value: '8192.0',
            label: 'Stack2 퓨즈 열림'
          },
          {
            value: '16384.0',
            label: 'Stack3 퓨즈 열림'
          },
          {
            value: '32768.0',
            label: 'Stack4 퓨즈 열림'
          },
          {
            value: '256.0',
            label: '계통출력 과전압'
          },
          {
            value: '128.0',
            label: '패널 비상 정지'
          },
          {
            value: '512.0',
            label: '패널문 개방'
          },
          {
            value: '1024.0',
            label: 'TR 패널문 개방'
          },
          {
            value: '2048.0',
            label: 'TR 과열'
          }
        ]
      } else if (this.select2 === 'PVPCS') {
        return [
          {
            value: '0.0',
            label: '이상없음'
          },
          {
            value: '1.0',
            label: '입력 과전류'
          },
          {
            value: '2.0',
            label: '출력 과전압'
          },
          {
            value: '4.0',
            label: '출력 저전압'
          },
          {
            value: '8.0',
            label: '출력 과전류'
          },
          {
            value: '16.0',
            label: '접촉기(K1) 이상'
          },
          {
            value: '32.0',
            label: '계통전류 불평형'
          }
        ]
      }
      return [{
        value: '0.0',
        label: '이상없음'
      }]
    },
    status3List() {
      if (this.select2 === 'EPCS') {
        return [
          {
            value: '0.0',
            label: '이상없음'
          },
          {
            value: '1.0',
            label: 'AC 퓨즈1 열림'
          },
          {
            value: '2.0',
            label: 'AC 퓨즈2 열림'
          },
          {
            value: '4.0',
            label: 'AC 퓨즈43 열림'
          },
          {
            value: '8.0',
            label: 'AC 퓨즈4 열림'
          },
          {
            value: '16.0',
            label: 'AC 리액터1 과온'
          },
          {
            value: '32.0',
            label: 'AC 리액터2 과온'
          },
          {
            value: '64.0',
            label: 'AC 리액터3 과온'
          },
          {
            value: '128.0',
            label: 'AC 리액터4 과온'
          },
          {
            value: '256.0',
            label: 'AC 리액터1 과열'
          },
          {
            value: '512.0',
            label: 'AC 리액터2 과열'
          },
          {
            value: '1024.0',
            label: 'AC 리액터3 과열'
          },
          {
            value: '2048.0',
            label: 'AC 리액터4 과열'
          },
          {
            value: '4096.0',
            label: 'DC 리액터1 과열'
          },
          {
            value: '8192.0',
            label: 'DC 리액터2 과열'
          },
          {
            value: '16384.0',
            label: 'DC 리액터3 과열'
          },
          {
            value: '32768.0',
            label: 'DC 리액터4 과열'
          }
        ]
      }
      return [{
        value: '0.0',
        label: '이상없음'
      }]
    },
    status4List() {
      if (this.select2 === 'EPCS') {
        return [
          {
            value: '0.0',
            label: '이상없음'
          },
          {
            value: '1.0',
            label: 'Stack1 IGBT 과온'
          },
          {
            value: '2.0',
            label: 'Stack2 IGBT 과온'
          },
          {
            value: '4.0',
            label: 'Stack3 IGBT 과온'
          },
          {
            value: '8.0',
            label: 'Stack4 IGBT 과온'
          },
          {
            value: '16.0',
            label: 'Heat-sink1 과온'
          },
          {
            value: '32.0',
            label: 'Heat-sink2 과온'
          },
          {
            value: '64.0',
            label: 'Heat-sink3 과온'
          },
          {
            value: '128.0',
            label: 'Heat-sink4 과온'
          },
          {
            value: '4096.0',
            label: '배터리 Trip'
          },
          {
            value: '8192.0',
            label: '배터리 통신 오류'
          },
          {
            value: '16384.0',
            label: '배터리 연결 오류'
          }
        ]
      }
      return [{
        value: '0.0',
        label: '이상없음'
      }]
    },
    gridRetrieveApi() {
      return this.retrieveApi
    },
    gridRetrieveErrorApi() {
      return this.retrieveApiErrorRecord
    },
    comboList() {
      let type = this.select2 === 'PVPCS' ? 'PVPCS' : this.select2 === 'EPCS' ? 'EPCS' : 'BSC'
      let all = {
        PVPCS: {
          text: '태양광 인버터 전체',
          value: 'PVPCS'
        },
        EPCS: {
          text: 'ESS PCS 전체',
          value: 'PVPCS'
        },
        BSC: {
          text: '배터리 전체',
          value: 'BSC'
        }
      }
      let list = []
      list.push(all[type])
      for (let item of this.essResult) {
        if (item.photo === type) {
          list.push({
            text: item.description,
            value: item.codeid
          })
        }
      }
      return list
    },
    pCodeId() {
      let type = this.select2 === 'PVPCS' ? 'PVPCS' : this.select2 === 'EPCS' ? 'EPCS' : 'BSC'
      let allCheck = this.select === 'PVPCS' || this.select === 'EPCS' || this.select === 'BSC'
      let id = ''
      if (allCheck) {
        for (let item of this.essResult) {
          if (item.photo === type) {
            id = item.pcodeid
            break
          }
        }
      }
      return id
    }
  },
  watch: {
    comboList() {
      this.select = this.comboList[0].value
    },
    select2() {
      this.$refs.dataGrid2.getDataProvider().clearRows()
      if (this.select2 === 'EPCS') {
        this.$refs.dataGrid2
          .getGridView()
          .setColumnProperty('status3', 'visible', true)
      } else {
        this.$refs.dataGrid2
          .getGridView()
          .setColumnProperty('status3', 'visible', false)
      }
    }
  },
  methods: {
    retrieveGrid() {
      this.$refs.dataGrid.getDataProvider().clearRows()
      this.$refs.dataGrid.retrieve()
    },
    retrieveGrid2() {
      this.$refs.dataGrid2.getDataProvider().clearRows()
      this.$refs.dataGrid2.retrieve()
    },
    retrieveApi() {
      return new Promise((resolve, reject) => {
        let params = {
          code_id: this.pCodeId || this.select,
          startDate: this.startDate,
          endDate: this.endDate
        }
        if (this.essData.essData.length > 0) {
          getWorkRecord(params).then(res => {
            resolve(res)
          })
        }
      })
    },
    retrieveApiErrorRecord() {
      return new Promise((resolve, reject) => {
        let params = {
          siteId: this.site_id,
          type: this.select2,
          startDate: this.startDate,
          endDate: this.endDate
        }
        if (this.essData.essData.length > 0) {
          getWorkErrorRecord(params).then(res => {
            resolve(res)
          })
        }
      })
    },
    initData() {
      if (this.essData.result !== 'noData') {
        this.essResult = this.essData.essResult
      }
      this.errorGrid.gridColumns = [
        {
          name: 'date',
          fieldName: 'date',
          header: {
            text: '일자'
          },
          styles: {
            background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
          },
          // editable 옵션이 false 일 경우, 수정할 수 없다.
          editable: false
        },
        {
          name: 'time',
          fieldName: 'time',
          header: {
            text: '시간'
          },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'subcomp',
          fieldName: 'subcomp',
          header: {
            text: '인버터 번호'
          },
          styles: {
            textAlignment: 'center',
            background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
          }
        },
        {
          name: 'status1',
          fieldName: 'status1',
          header: {
            text: '상태1'
          },
          lookupDisplay: true,
          values: this.status1List.map(item => item.value),
          labels: this.status1List.map(item => item.label),
          styles: {
            background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
          }
        },
        {
          name: 'status2',
          fieldName: 'status2',
          header: {
            text: '상태2'
          },
          lookupDisplay: true,
          values: this.status2List.map(item => item.value),
          labels: this.status2List.map(item => item.label),
          styles: {
            background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
          }
        },
        {
          name: 'status3',
          fieldName: 'status3',
          header: {
            text: '상태3'
          },
          lookupDisplay: true,
          values: this.status3List.map(item => item.value),
          labels: this.status3List.map(item => item.label),
          styles: {
            background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
          }
        }
      ]
    },
    changeComponent(e) {
      let component = e.target.value

      this.isPvpcsSelected = false
      this.isEpcsSelected = false
      this.isBscSelected = false

      if (component === 'EPCS') {
        this.isEpcsSelected = true
      } else if (component === 'BSC') {
        this.isBscSelected = true
      } else {
        this.isPvpcsSelected = true
      }
    },
    excelDown() {
      // 엑셀다운로드
      let gridView = this.$refs.dataGrid.getGridView()
      gridView.exportGrid({
        type: 'excel',
        target: 'local',
        fileName: '운전/정지이력_' + day().format('YYYY-MM-DD') + '.xlsx',
        indicator: 'visible',
        footer: 'hidden',
        header: 'visible',
        allColumns: true,
        done: function () {
          Message.success('출력이 완료되었습니다.')
        }
      })
    },
    excelDown2() {
      // 엑셀다운로드
      let gridView = this.$refs.dataGrid2.getGridView()
      gridView.exportGrid({
        type: 'excel',
        target: 'local',
        fileName: '운전/정지이력_' + day().format('YYYY-MM-DD') + '.xlsx',
        indicator: 'visible',
        footer: 'hidden',
        header: 'visible',
        allColumns: true,
        done: function () {
          Message.success('출력이 완료되었습니다.')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

#realgrid {
  height: 442.5px;
}

.excel_down {
  width: 100px;
  height: 30px;
  border: 1px solid #24943e;
  color: #24943e;
  text-align: center;
  line-height: 30px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;
}

.workSearchBtn {
  width: 55px;
  height: 28px;
  float: left;
  background-color: #2976d2;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  padding-top: 4px;
}
</style>
